import http from 'services/Http';

export default {
  render(contentId, language) {
    return http.get(`/v1/content/render/${contentId}/${language}`);
  },
};
